(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dsiv-collection-terminal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function normalize(value) {
      return String(value || "").trim().toLowerCase();
    }

    function cardValue(card, key) {
      return card.getAttribute("data-dsiv-" + key) || "";
    }

    function numericCardValue(card, key) {
      var raw = cardValue(card, key).replace(/[^\d.]/g, "");
      if (!raw) return null;
      var parsed = Number(raw);
      return Number.isFinite(parsed) ? parsed : null;
    }

    function optionLabel(value) {
      return String(value || "").trim();
    }

    function populateFilter(select, cards, key) {
      if (!select) return;
      var firstOption = select.querySelector("option");
      select.innerHTML = "";
      if (firstOption) select.appendChild(firstOption);

      Array.from(new Set(cards.map(function (card) {
        return optionLabel(cardValue(card, key));
      }).filter(Boolean))).sort(function (left, right) {
        return left.localeCompare(right, undefined, { sensitivity: "base" });
      }).forEach(function (value) {
        var option = document.createElement("option");
        option.value = normalize(value);
        option.textContent = value;
        select.appendChild(option);
      });
    }

    function compareText(left, right, key) {
      return cardValue(left, key).localeCompare(cardValue(right, key), undefined, { sensitivity: "base" });
    }

    function compareNumber(left, right, key, direction) {
      var leftValue = numericCardValue(left, key);
      var rightValue = numericCardValue(right, key);
      if (leftValue === null && rightValue === null) return 0;
      if (leftValue === null) return 1;
      if (rightValue === null) return -1;
      return direction === "desc" ? rightValue - leftValue : leftValue - rightValue;
    }

    var activePreviewAudio = null;
    var sharedAudioContext = null;

    function cardIdentity(card) {
      var link = card.querySelector("a[href]");
      return card.getAttribute("data-dsiv-url") || (link && link.getAttribute("href")) || cardValue(card, "title");
    }

    function formatPreviewTime(seconds) {
      if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
      var minutes = Math.floor(seconds / 60);
      var remainder = Math.floor(seconds % 60);
      return minutes + ":" + String(remainder).padStart(2, "0");
    }

    function setPreviewState(root, preview, state) {
      if (!preview) return;
      var audio = preview.querySelector("[data-dsiv-audio]");
      var button = preview.querySelector("[data-dsiv-audio-toggle]");
      var label = preview.querySelector("[data-dsiv-audio-button-label]");
      var status = preview.querySelector("[data-dsiv-audio-status]");
      var time = preview.querySelector("[data-dsiv-audio-time]");
      var isPlaying = state === "playing";
      var playLabel = button && button.dataset.playLabel ? button.dataset.playLabel : "Play";
      var pauseLabel = button && button.dataset.pauseLabel ? button.dataset.pauseLabel : "Pause";

      if (button) {
        var trackTitle = preview.dataset.dsivTrackTitle || "";
        var buttonLabel = isPlaying ? pauseLabel : playLabel;
        var ariaLabel = trackTitle ? buttonLabel + " " + trackTitle : buttonLabel;
        button.setAttribute("aria-pressed", isPlaying ? "true" : "false");
        button.setAttribute("aria-label", ariaLabel);
      }
      if (label) label.textContent = isPlaying ? pauseLabel : playLabel;
      if (status) {
        if (state === "error") {
          status.textContent = root.dataset.dsivPreviewError || "Preview unavailable";
        } else if (isPlaying) {
          status.textContent = root.dataset.dsivPreviewPlaying || "Playing preview";
        } else {
          status.textContent = root.dataset.dsivPreviewReady || "Preview ready";
        }
      }
      if (time && audio) {
        time.textContent = formatPreviewTime(audio.currentTime);
        time.setAttribute("datetime", "PT" + Math.floor(audio.currentTime || 0) + "S");
      }
    }

    function createShader(gl, type, source) {
      var shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        gl.deleteShader(shader);
        return null;
      }
      return shader;
    }

    function createVisualizer(canvas, analyser) {
      var gl = canvas && canvas.getContext && canvas.getContext("webgl", { alpha: true, antialias: false });
      if (!gl) return null;

      var vertexShader = createShader(gl, gl.VERTEX_SHADER, [
        "attribute vec2 a_position;",
        "attribute float a_amp;",
        "varying float v_amp;",
        "void main() {",
        "  v_amp = a_amp;",
        "  gl_Position = vec4(a_position, 0.0, 1.0);",
        "}"
      ].join("\n"));
      var fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, [
        "precision mediump float;",
        "varying float v_amp;",
        "void main() {",
        "  vec3 cobalt = vec3(0.105, 0.341, 0.839);",
        "  vec3 warm = vec3(0.906, 0.714, 0.333);",
        "  float glow = smoothstep(0.08, 1.0, v_amp);",
        "  gl_FragColor = vec4(mix(cobalt, warm, glow), 0.86);",
        "}"
      ].join("\n"));
      if (!vertexShader || !fragmentShader) return null;

      var program = gl.createProgram();
      gl.attachShader(program, vertexShader);
      gl.attachShader(program, fragmentShader);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return null;

      var buffer = gl.createBuffer();
      var positionLocation = gl.getAttribLocation(program, "a_position");
      var ampLocation = gl.getAttribLocation(program, "a_amp");
      var frequencyData = analyser ? new Uint8Array(analyser.frequencyBinCount) : null;
      var bars = 32;

      function resize() {
        var rect = canvas.getBoundingClientRect();
        var scale = Math.min(window.devicePixelRatio || 1, 2);
        var width = Math.max(1, Math.floor(rect.width * scale));
        var height = Math.max(1, Math.floor(rect.height * scale));
        if (canvas.width !== width || canvas.height !== height) {
          canvas.width = width;
          canvas.height = height;
        }
        gl.viewport(0, 0, canvas.width, canvas.height);
      }

      function render(isPlaying) {
        resize();
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);

        if (analyser && frequencyData) analyser.getByteFrequencyData(frequencyData);

        var now = performance.now() / 1000;
        var vertices = [];
        var gap = 0.012;
        for (var index = 0; index < bars; index += 1) {
          var bucketStart = frequencyData ? Math.floor(index * frequencyData.length / bars) : 0;
          var bucketEnd = frequencyData ? Math.floor((index + 1) * frequencyData.length / bars) : 0;
          var sum = 0;
          var count = Math.max(bucketEnd - bucketStart, 1);
          for (var bucket = bucketStart; bucket < bucketEnd; bucket += 1) {
            sum += frequencyData[bucket] || 0;
          }
          var audioAmp = frequencyData ? sum / count / 255 : 0;
          var idleAmp = 0.2 + 0.16 * Math.sin(now * 2.2 + index * 0.6);
          var amp = isPlaying ? Math.max(audioAmp, idleAmp * 0.35) : idleAmp;
          var x0 = -1 + (index / bars) * 2 + gap;
          var x1 = -1 + ((index + 1) / bars) * 2 - gap;
          var y0 = -0.78;
          var y1 = Math.min(0.92, y0 + 0.22 + amp * 1.5);
          vertices.push(x0, y0, amp, x1, y0, amp, x0, y1, amp, x0, y1, amp, x1, y0, amp, x1, y1, amp);
        }

        gl.useProgram(program);
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.DYNAMIC_DRAW);
        gl.enableVertexAttribArray(positionLocation);
        gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 12, 0);
        gl.enableVertexAttribArray(ampLocation);
        gl.vertexAttribPointer(ampLocation, 1, gl.FLOAT, false, 12, 8);
        gl.drawArrays(gl.TRIANGLES, 0, vertices.length / 3);
      }

      return { render: render };
    }

    function ensureAudioGraph(preview, audio) {
      if (audio.dsivPreviewGraph !== undefined) return audio.dsivPreviewGraph;
      var AudioContextConstructor = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextConstructor) {
        audio.dsivPreviewGraph = null;
        return null;
      }
      if (!sharedAudioContext) sharedAudioContext = new AudioContextConstructor();
      try {
        var source = sharedAudioContext.createMediaElementSource(audio);
        var analyser = sharedAudioContext.createAnalyser();
        analyser.fftSize = 256;
        analyser.smoothingTimeConstant = 0.78;
        source.connect(analyser);
        analyser.connect(sharedAudioContext.destination);
        var canvas = preview.querySelector("[data-dsiv-audio-visualizer] canvas");
        audio.dsivPreviewGraph = {
          analyser: analyser,
          visualizer: createVisualizer(canvas, analyser)
        };
      } catch (error) {
        audio.dsivPreviewGraph = null;
      }
      return audio.dsivPreviewGraph;
    }

    function renderPreview(preview, audio, force) {
      var graph = audio.dsivPreviewGraph || null;
      var visualizer = graph && graph.visualizer ? graph.visualizer : null;
      if (visualizer) visualizer.render(!audio.paused && !audio.ended);
      if ((!audio.paused && !audio.ended) || force) {
        window.cancelAnimationFrame(audio.dsivPreviewFrame || 0);
        audio.dsivPreviewFrame = window.requestAnimationFrame(function () {
          renderPreview(preview, audio, false);
        });
      }
    }

    function setupPreviewCard(root, card) {
      var preview = card.querySelector("[data-dsiv-audio-preview]");
      if (!preview || preview.dataset.dsivPreviewReady === "true") return;
      var audio = preview.querySelector("[data-dsiv-audio]");
      if (!audio) return;
      preview.dataset.dsivPreviewReady = "true";

      audio.addEventListener("timeupdate", function () {
        setPreviewState(root, preview, audio.paused ? "ready" : "playing");
      });
      audio.addEventListener("play", function () {
        setPreviewState(root, preview, "playing");
        renderPreview(preview, audio, true);
      });
      audio.addEventListener("pause", function () {
        setPreviewState(root, preview, "ready");
      });
      audio.addEventListener("ended", function () {
        audio.currentTime = 0;
        setPreviewState(root, preview, "ready");
        renderPreview(preview, audio, true);
      });
      audio.addEventListener("error", function () {
        setPreviewState(root, preview, "error");
      });

      setPreviewState(root, preview, "ready");
    }

    function initCatalogSection(root) {
      if (!root || root.dataset.dsivCatalogReady === "true") return;

      var grid = root.querySelector("[data-dsiv-catalog-grid]");
      var cards = Array.from(root.querySelectorAll("[data-dsiv-track-card]"));
      if (!grid || !cards.length) return;

      root.dataset.dsivCatalogReady = "true";
      cards.forEach(function (card, index) {
        card.setAttribute("data-dsiv-original-index", String(index));
        setupPreviewCard(root, card);
      });

      var search = root.querySelector("[data-dsiv-catalog-search]");
      var genre = root.querySelector('[data-dsiv-catalog-filter="genre"]');
      var license = root.querySelector('[data-dsiv-catalog-filter="license"]');
      var key = root.querySelector('[data-dsiv-catalog-filter="key"]');
      var preview = root.querySelector('[data-dsiv-catalog-filter="preview"]');
      var sort = root.querySelector("[data-dsiv-catalog-sort]");
      var reset = root.querySelector("[data-dsiv-catalog-reset]");
      var count = root.querySelector("[data-dsiv-catalog-count]");
      var empty = root.querySelector("[data-dsiv-catalog-empty]");
      var tools = root.querySelector(".dsiv-collection-terminal__tools");
      var pagination = root.querySelector(".dsiv-collection-terminal__pagination");
      var indexStatus = root.querySelector("[data-dsiv-catalog-index-status]");
      var plural = root.dataset.dsivCountPlural || "tracks shown";
      var singular = root.dataset.dsivCountSingular || "track shown";
      var totalPages = Number(tools && tools.dataset.dsivCatalogPageCount || 1);
      var currentPage = Number(tools && tools.dataset.dsivCatalogCurrentPage || 1);
      var totalItems = Number(tools && tools.dataset.dsivCatalogTotalItems || cards.length);
      var pageLoadFailed = false;
      var indexedPages = new Set([currentPage]);
      var cardKeys = new Set(cards.map(function (card) {
        return cardIdentity(card);
      }));

      root.addEventListener("click", function (event) {
        var button = event.target.closest && event.target.closest("[data-dsiv-audio-toggle]");
        if (!button || !root.contains(button)) return;
        var previewWrapper = button.closest("[data-dsiv-audio-preview]");
        var audio = previewWrapper && previewWrapper.querySelector("[data-dsiv-audio]");
        if (!previewWrapper || !audio) return;

        event.preventDefault();
        event.stopPropagation();

        if (activePreviewAudio && activePreviewAudio !== audio) {
          activePreviewAudio.pause();
        }

        if (!audio.paused && !audio.ended) {
          audio.pause();
          return;
        }

        var graph = ensureAudioGraph(previewWrapper, audio);
        var context = sharedAudioContext;
        var resumePromise = context && context.state === "suspended" ? context.resume() : Promise.resolve();
        resumePromise.then(function () {
          return audio.play();
        }).then(function () {
          activePreviewAudio = audio;
          setPreviewState(root, previewWrapper, "playing");
          if (graph && graph.visualizer) renderPreview(previewWrapper, audio, true);
        }).catch(function () {
          setPreviewState(root, previewWrapper, "error");
        });
      });

      function setIndexStatus(message, isHidden) {
        if (!indexStatus) return;
        indexStatus.textContent = message;
        indexStatus.hidden = Boolean(isHidden);
      }

      function repopulateFilter(select, attribute) {
        if (!select) return;
        var selected = select.value;
        populateFilter(select, cards, attribute);
        if (!selected) return;
        var hasSelected = Array.from(select.options).some(function (option) {
          return option.value === selected;
        });
        select.value = hasSelected ? selected : "";
      }

      function refreshFilterOptions() {
        repopulateFilter(genre, "genre");
        repopulateFilter(license, "license");
        repopulateFilter(key, "key");
      }

      refreshFilterOptions();

      function matchesSelect(card, select, attribute) {
        if (!select || !select.value) return true;
        return normalize(cardValue(card, attribute)) === select.value;
      }

      function matchesSearch(card) {
        var query = normalize(search && search.value);
        if (!query) return true;
        return [
          cardValue(card, "title"),
          cardValue(card, "type"),
          cardValue(card, "genre"),
          cardValue(card, "license"),
          cardValue(card, "key"),
          cardValue(card, "bpm")
        ].join(" ").toLowerCase().includes(query);
      }

      function sortedCards() {
        var ordered = cards.slice();
        var mode = sort && sort.value ? sort.value : "recommended";
        ordered.sort(function (left, right) {
          if (mode === "title-asc") return compareText(left, right, "title");
          if (mode === "price-asc") return compareNumber(left, right, "price", "asc");
          if (mode === "price-desc") return compareNumber(left, right, "price", "desc");
          if (mode === "bpm-asc") return compareNumber(left, right, "bpm", "asc");
          if (mode === "bpm-desc") return compareNumber(left, right, "bpm", "desc");
          return Number(left.dataset.dsivOriginalIndex || 0) - Number(right.dataset.dsivOriginalIndex || 0);
        });
        return ordered;
      }

      function countText(visibleCount) {
        var loadedTotal = Math.max(cards.length, visibleCount);
        var expectedTotal = totalItems > loadedTotal ? totalItems : loadedTotal;
        var label = visibleCount === 1 ? singular : plural;
        if (expectedTotal > visibleCount) {
          return visibleCount + " / " + expectedTotal + " " + label;
        }
        return visibleCount + " " + label;
      }

      function applyFilters() {
        var visibleCount = 0;
        sortedCards().forEach(function (card) {
          var previewMode = preview && preview.value ? preview.value : "";
          var isVisible = matchesSearch(card)
            && matchesSelect(card, genre, "genre")
            && matchesSelect(card, license, "license")
            && matchesSelect(card, key, "key")
            && (!previewMode || cardValue(card, "preview") === previewMode);

          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
          grid.appendChild(card);
        });

        if (count) count.textContent = countText(visibleCount);
        if (empty) empty.hidden = visibleCount !== 0;
      }

      function pageUrl(pageNumber) {
        var url = new URL(window.location.href);
        url.searchParams.set("page", String(pageNumber));
        return url.toString();
      }

      function appendIndexedCards(html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var sectionId = root.dataset.dsivCatalogSection || "";
        var selector = sectionId
          ? '[data-dsiv-catalog-section="' + sectionId + '"] [data-dsiv-track-card]'
          : "[data-dsiv-track-card]";
        var nextCards = Array.from(doc.querySelectorAll(selector));
        if (!nextCards.length && sectionId) {
          nextCards = Array.from(doc.querySelectorAll("[data-dsiv-track-card]"));
        }

        nextCards.forEach(function (card) {
          var cardKey = cardIdentity(card);
          if (!cardKey || cardKeys.has(cardKey)) return;
          cardKeys.add(cardKey);
          card.setAttribute("data-dsiv-original-index", String(cards.length));
          card.hidden = false;
          setupPreviewCard(root, card);
          cards.push(card);
          grid.appendChild(card);
        });
      }

      function loadRemainingPages() {
        if (!window.fetch || totalPages <= 1) return;

        var pages = [];
        for (var pageNumber = 1; pageNumber <= totalPages; pageNumber += 1) {
          if (pageNumber !== currentPage && !indexedPages.has(pageNumber)) {
            pages.push(pageNumber);
          }
        }
        if (!pages.length) return;

        setIndexStatus(tools && tools.dataset.dsivCatalogIndexLoading || "Indexing full catalog...", false);

        var loadedPages = indexedPages.size;
        pages.reduce(function (chain, pageNumber) {
          return chain.then(function () {
            return fetch(pageUrl(pageNumber), { credentials: "same-origin" })
              .then(function (response) {
                if (!response.ok) throw new Error("Catalog page " + pageNumber + " returned " + response.status);
                return response.text();
              })
              .then(function (html) {
                indexedPages.add(pageNumber);
                loadedPages += 1;
                appendIndexedCards(html);
                refreshFilterOptions();
                applyFilters();
                setIndexStatus((tools && tools.dataset.dsivCatalogIndexLoading || "Indexing full catalog...") + " " + loadedPages + " / " + totalPages, false);
              });
          });
        }, Promise.resolve()).then(function () {
          if (!pageLoadFailed && indexedPages.size >= totalPages) {
            if (pagination) pagination.hidden = true;
            setIndexStatus(tools && tools.dataset.dsivCatalogIndexReady || "Full catalog indexed.", false);
          }
        }).catch(function () {
          pageLoadFailed = true;
          setIndexStatus(tools && tools.dataset.dsivCatalogIndexFallback || "Showing current page. Use pagination if a track does not appear.", false);
        });
      }

      [search, genre, license, key, preview, sort].forEach(function (control) {
        if (!control) return;
        control.addEventListener("input", applyFilters);
        control.addEventListener("change", applyFilters);
      });

      if (reset) {
        reset.addEventListener("click", function () {
          [search, genre, license, key, preview, sort].forEach(function (control) {
            if (!control) return;
            control.value = control === sort ? "recommended" : "";
          });
          applyFilters();
          if (search) search.focus();
        });
      }

      applyFilters();
      loadRemainingPages();
    }

    function initAllCatalogSections(scope) {
      var rootScope = scope || document;
      if (rootScope.matches && rootScope.matches("[data-dsiv-catalog-section]")) {
        initCatalogSection(rootScope);
      }
      rootScope.querySelectorAll("[data-dsiv-catalog-section]").forEach(initCatalogSection);
    }

    initAllCatalogSections(document);
    document.addEventListener("shopify:section:load", function (event) {
      initAllCatalogSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-contact-terminal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.getElementById('DsivContactForm');
    if (!form) return;

    const contactEmail = form.dataset.dsivContactEmail || 'info@dsivmedia.com';
    const successMessage = form.dataset.dsivSuccessMessage || 'Open your email app to send the DSIV request.';
    const copySuccessMessage = form.dataset.dsivCopySuccessMessage || 'Brief copied.';
    const copyErrorMessage = form.dataset.dsivCopyErrorMessage || 'Copy did not complete.';
    const params = new URLSearchParams(window.location.search);
    const status = form.querySelector('[data-dsiv-mailto-status]');
    const copyButton = form.querySelector('[data-dsiv-copy-request]');
    const selectByValue = (name, value) => {
      if (!value) return;

      const field = form.querySelector(`[name="${name}"]`);
      if (!field || !field.options) return;

      const match = Array.from(field.options).find((option) => option.value.toLowerCase() === value.toLowerCase());
      if (match) field.value = match.value;
    };

    selectByValue('contact[service_type]', params.get('service'));
    selectByValue('contact[budget]', params.get('budget'));
    selectByValue('contact[timeline]', params.get('timeline'));
    selectByValue('contact[intended_use]', params.get('intended_use'));

    const note = params.get('note') || params.get('notes');
    const body = form.querySelector('[name="contact[body]"]');
    if (note && body && !body.value.trim()) {
      body.value = note;
    }

    const deliverables = params.get('deliverables');
    const deliverablesField = form.querySelector('[name="contact[deliverables_needed]"]');
    if (deliverables && deliverablesField && !deliverablesField.value.trim()) {
      deliverablesField.value = deliverables;
    }

    const sourceUrl = form.querySelector('[data-dsiv-source-url-field]');
    if (sourceUrl) {
      sourceUrl.value = window.location.href;
    }

    const requestContext = form.querySelector('[data-dsiv-request-context]');
    const requestContextField = form.querySelector('[data-dsiv-request-context-field]');
    const contextTitle = form.querySelector('[data-dsiv-context-title]');
    const contextNote = form.querySelector('[data-dsiv-context-note]');
    const contextLabels = requestContext ? requestContext.dataset : {};

    const getFieldValue = (name) => {
      const field = form.querySelector(`[name="${name}"]`);
      return field ? field.value.trim() : '';
    };

    const syncRequestContext = () => {
      const service = getFieldValue('contact[service_type]');
      const budget = getFieldValue('contact[budget]');
      const timeline = getFieldValue('contact[timeline]');
      const intendedUse = getFieldValue('contact[intended_use]');
      const deliverablesValue = getFieldValue('contact[deliverables_needed]');
      const bodyValue = getFieldValue('contact[body]');
      const details = [];

      if (service) details.push(`${contextLabels.serviceLabel || 'Service type'}: ${service}`);
      if (budget) details.push(`${contextLabels.budgetLabel || 'Budget'}: ${budget}`);
      if (timeline) details.push(`${contextLabels.timelineLabel || 'Timeline'}: ${timeline}`);
      if (intendedUse) details.push(`${contextLabels.intendedUseLabel || 'Intended use'}: ${intendedUse}`);
      if (deliverablesValue) details.push(`${contextLabels.deliverablesLabel || 'Deliverables needed'}: ${deliverablesValue}`);
      if (bodyValue) details.push(`${contextLabels.noteLabel || 'Project notes'}: ${bodyValue}`);

      if (requestContextField) {
        requestContextField.value = details.join('\n');
      }
    };

    const buildRequestSummary = () => {
      syncRequestContext();

      const lines = [
        'DSIV Project Request',
        '',
        `Name: ${getFieldValue('contact[name]')}`,
        `Email: ${getFieldValue('contact[email]')}`,
        `Phone: ${getFieldValue('contact[phone]')}`,
        `Service type: ${getFieldValue('contact[service_type]')}`,
        `Budget: ${getFieldValue('contact[budget]')}`,
        `Timeline: ${getFieldValue('contact[timeline]')}`,
        `Intended use: ${getFieldValue('contact[intended_use]')}`,
        `Project link: ${getFieldValue('contact[project_link]')}`,
        '',
        'Deliverables needed:',
        getFieldValue('contact[deliverables_needed]'),
        '',
        'Project notes:',
        getFieldValue('contact[body]'),
        '',
        `Source URL: ${window.location.href}`,
      ];

      return lines.join('\n');
    };

    const buildMailtoHref = () => {
      const service = getFieldValue('contact[service_type]') || 'Project request';
      const subject = `DSIV request - ${service}`;
      return `mailto:${contactEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(buildRequestSummary())}`;
    };

    const setStatus = (message) => {
      if (!status) return;
      status.textContent = message;
      status.hidden = false;
      status.focus();
    };

    const showHandoffContext = () => {
      if (!requestContext || !contextTitle) return;

      const service = getFieldValue('contact[service_type]');
      const budget = getFieldValue('contact[budget]');
      const timeline = getFieldValue('contact[timeline]');
      const intendedUse = getFieldValue('contact[intended_use]');
      const summary = [service, budget, timeline, intendedUse].filter(Boolean).join(' / ');

      if (!summary && !note && !deliverables) return;

      contextTitle.textContent = summary || note || deliverables;
      if (contextNote) {
        contextNote.textContent = [deliverables, note].filter(Boolean).join(' / ');
        contextNote.hidden = !contextNote.textContent;
      }
      requestContext.hidden = false;
    };

    ['contact[service_type]', 'contact[budget]', 'contact[timeline]', 'contact[intended_use]', 'contact[deliverables_needed]', 'contact[body]'].forEach((name) => {
      const field = form.querySelector(`[name="${name}"]`);
      if (field) {
        field.addEventListener('change', syncRequestContext);
        field.addEventListener('input', syncRequestContext);
      }
    });

    syncRequestContext();
    showHandoffContext();
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      syncRequestContext();
      window.location.href = buildMailtoHref();
      setStatus(successMessage);
    });

    if (copyButton) {
      copyButton.addEventListener('click', async () => {
        const summary = buildRequestSummary();
        try {
          await navigator.clipboard.writeText(summary);
          setStatus(copySuccessMessage);
        } catch (error) {
          setStatus(copyErrorMessage);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-product-license-terminal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let activeAudio = null;
    let sharedAudioContext = null;

    const formatPreviewTime = (seconds) => {
      if (!Number.isFinite(seconds)) return '0:00';
      const safeSeconds = Math.max(0, Math.floor(seconds));
      const minutes = Math.floor(safeSeconds / 60);
      const remainder = String(safeSeconds % 60).padStart(2, '0');
      return `${minutes}:${remainder}`;
    };

    const setPreviewState = (preview, state) => {
      const audio = preview.querySelector('[data-dsiv-product-audio]');
      const button = preview.querySelector('[data-dsiv-product-audio-toggle]');
      const buttonLabel = preview.querySelector('[data-dsiv-product-audio-button-label]');
      const status = preview.querySelector('[data-dsiv-product-audio-status]');
      const time = preview.querySelector('[data-dsiv-product-audio-time]');
      const isPlaying = state === 'playing';

      if (button) {
        const label = isPlaying ? button.dataset.pauseLabel : button.dataset.playLabel;
        const trackTitle = preview.dataset.trackTitle || '';
        const ariaLabel = trackTitle ? `${label} ${trackTitle}` : label;
        button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
        button.setAttribute('aria-label', ariaLabel || '');
        if (buttonLabel && label) buttonLabel.textContent = label;
      }

      if (status) {
        if (state === 'error') {
          status.textContent = preview.dataset.previewError || 'Preview unavailable';
        } else if (isPlaying) {
          status.textContent = preview.dataset.previewPlaying || 'Playing preview';
        } else {
          status.textContent = preview.dataset.previewReady || 'Preview ready';
        }
      }

      if (time && audio) {
        const value = formatPreviewTime(audio.currentTime);
        time.textContent = value;
        time.setAttribute('datetime', `PT${Math.max(0, Math.floor(audio.currentTime || 0))}S`);
      }
    };

    const createVisualizer = (canvas, analyser) => {
      const gl = canvas && canvas.getContext && canvas.getContext('webgl', { alpha: true, antialias: false });
      if (!gl) return null;

      const data = new Uint8Array(analyser.frequencyBinCount);
      const bars = 36;

      const resize = () => {
        const rect = canvas.getBoundingClientRect();
        const scale = Math.min(window.devicePixelRatio || 1, 2);
        const width = Math.max(1, Math.floor(rect.width * scale));
        const height = Math.max(1, Math.floor(rect.height * scale));
        if (canvas.width !== width || canvas.height !== height) {
          canvas.width = width;
          canvas.height = height;
        }
      };

      const render = (active) => {
        resize();
        if (active) analyser.getByteFrequencyData(data);

        const width = canvas.width;
        const height = canvas.height;
        gl.viewport(0, 0, width, height);
        gl.disable(gl.SCISSOR_TEST);
        gl.clearColor(0.012, 0.02, 0.04, 0.72);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.enable(gl.SCISSOR_TEST);

        const gap = Math.max(2, Math.floor(width * 0.006));
        const barWidth = Math.max(2, Math.floor((width - gap * (bars - 1)) / bars));

        for (let index = 0; index < bars; index += 1) {
          const dataIndex = Math.min(data.length - 1, Math.floor((index / bars) * data.length));
          const idle = 38 + Math.sin(Date.now() / 360 + index * 0.72) * 22;
          const value = active ? data[dataIndex] : idle;
          const normalized = Math.max(0.06, Math.min(1, value / 255));
          const barHeight = Math.max(4, Math.floor(height * normalized));
          const x = index * (barWidth + gap);
          const y = Math.max(0, Math.floor((height - barHeight) * 0.58));

          gl.scissor(x, y, barWidth, barHeight);
          gl.clearColor(0.1 + normalized * 0.22, 0.34 + normalized * 0.32, 0.82, 0.72);
          gl.clear(gl.COLOR_BUFFER_BIT);

          gl.scissor(x, Math.min(height - 1, y + barHeight - 2), barWidth, Math.min(3, barHeight));
          gl.clearColor(0.9, 0.72, 0.28, 0.88);
          gl.clear(gl.COLOR_BUFFER_BIT);
        }

        gl.disable(gl.SCISSOR_TEST);
      };

      return { render };
    };

    const connectAudioGraph = (audio, preview) => {
      if (audio.dsivProductPreviewGraph !== undefined) return audio.dsivProductPreviewGraph;

      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) {
          audio.dsivProductPreviewGraph = null;
          return null;
        }

        sharedAudioContext = sharedAudioContext || new AudioContext();
        const analyser = sharedAudioContext.createAnalyser();
        analyser.fftSize = 128;
        analyser.smoothingTimeConstant = 0.76;

        const source = audio.dsivProductPreviewSource || sharedAudioContext.createMediaElementSource(audio);
        audio.dsivProductPreviewSource = source;
        source.connect(analyser);
        analyser.connect(sharedAudioContext.destination);

        const canvas = preview.querySelector('[data-dsiv-product-audio-visualizer] canvas');
        audio.dsivProductPreviewGraph = {
          context: sharedAudioContext,
          visualizer: createVisualizer(canvas, analyser)
        };
      } catch (error) {
        audio.dsivProductPreviewGraph = null;
      }

      return audio.dsivProductPreviewGraph;
    };

    const renderPreview = (preview, audio) => {
      const graph = audio.dsivProductPreviewGraph || null;
      const visualizer = graph && graph.visualizer ? graph.visualizer : null;
      if (visualizer) visualizer.render(!audio.paused && !audio.ended);
      if (!audio.paused && !audio.ended) {
        window.cancelAnimationFrame(audio.dsivProductPreviewFrame || 0);
        audio.dsivProductPreviewFrame = window.requestAnimationFrame(() => {
          renderPreview(preview, audio);
        });
      }
    };

    const setupAudioPreview = (section) => {
      const preview = section.querySelector('[data-dsiv-product-audio-preview]');
      if (!preview || preview.dataset.dsivPreviewReady === 'true') return;

      const audio = preview.querySelector('[data-dsiv-product-audio]');
      const button = preview.querySelector('[data-dsiv-product-audio-toggle]');
      if (!audio || !button) return;

      preview.dataset.dsivPreviewReady = 'true';
      preview.classList.add('is-enhanced');

      audio.addEventListener('loadedmetadata', () => setPreviewState(preview, audio.paused ? 'ready' : 'playing'));
      audio.addEventListener('timeupdate', () => setPreviewState(preview, audio.paused ? 'ready' : 'playing'));
      audio.addEventListener('play', () => {
        setPreviewState(preview, 'playing');
        renderPreview(preview, audio);
      });
      audio.addEventListener('pause', () => {
        setPreviewState(preview, 'ready');
        renderPreview(preview, audio);
      });
      audio.addEventListener('ended', () => {
        setPreviewState(preview, 'ready');
        renderPreview(preview, audio);
      });
      audio.addEventListener('error', () => setPreviewState(preview, 'error'));

      button.addEventListener('click', async () => {
        const graph = connectAudioGraph(audio, preview);
        if (graph && graph.context && graph.context.state === 'suspended') {
          await graph.context.resume();
        }

        if (activeAudio && activeAudio !== audio) activeAudio.pause();

        if (audio.paused || audio.ended) {
          try {
            await audio.play();
            activeAudio = audio;
            setPreviewState(preview, 'playing');
            renderPreview(preview, audio);
          } catch (error) {
            setPreviewState(preview, 'error');
          }
        } else {
          audio.pause();
        }
      });

      const graph = connectAudioGraph(audio, preview);
      if (graph && graph.visualizer) graph.visualizer.render(false);
      setPreviewState(preview, 'ready');
    };

    const setupVariantSelect = (section) => {
      const select = section.querySelector('[data-dsiv-variant-select]');
      if (!select) return;

      const price = section.querySelector('[data-dsiv-product-price]');
      const button = section.querySelector('[data-dsiv-add-button]');

      const syncVariant = () => {
        const option = select.options[select.selectedIndex];
        if (!option) return;

        if (price && option.dataset.price) {
          price.textContent = option.dataset.price;
        }

        if (button) {
          const isAvailable = option.dataset.available === 'true';
          button.disabled = !isAvailable;
          button.textContent = isAvailable ? button.dataset.addLabel : button.dataset.soldLabel;
        }
      };

      select.addEventListener('change', syncVariant);
      syncVariant();
    };

    document.querySelectorAll('.dsiv-product-terminal').forEach((section) => {
      setupVariantSelect(section);
      setupAudioPreview(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-site-chrome"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const removeLegacyDsivCursor = () => {
      document.querySelectorAll("#logo-cursor, .cursor-trail").forEach((element) => element.remove());
    };

    removeLegacyDsivCursor();
    document.addEventListener("DOMContentLoaded", removeLegacyDsivCursor, { once: true });

    const dsivCursorObserver = new MutationObserver(removeLegacyDsivCursor);
    dsivCursorObserver.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-terminal-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatTime = (seconds) => {
      const safe = Number.isFinite(seconds) ? Math.max(0, seconds) : 0;
      return `${Math.floor(safe / 60)}:${String(Math.floor(safe % 60)).padStart(2, '0')}`;
    };

    const initHero = (root) => {
      const hero = root.querySelector('[data-dsiv-home-hero]');
      const canvas = root.querySelector('[data-dsiv-home-hero-fx]');
      if (!hero || !canvas || canvas.dataset.ready === 'true') return;
      canvas.dataset.ready = 'true';
      const gl = canvas.getContext('webgl', { alpha: true, antialias: false, depth: false });
      if (!gl) { canvas.hidden = true; return; }

      const vertexSource = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';
      const fragmentSource = `
        precision highp float;
        uniform vec2 r;
        uniform float t;
        float glow(float d,float w){return w/max(abs(d),.001);}
        void main(){
          vec2 uv=gl_FragCoord.xy/r.xy;
          float mask=smoothstep(.34,.58,uv.x);
          float y=.55+sin(uv.x*31.-t*2.15)*.014+sin(uv.x*67.+t*1.35)*.006;
          float wave=glow(uv.y-y,.0018)*mask;
          float scan=exp(-pow((uv.x-fract(t*.055+.35))*34.,2.))*mask;
          vec2 p=vec2(.69,.31);
          float d=length((uv-p)*vec2(r.x/r.y,1.));
          float orb=exp(-pow((d-.075)*36.,2.))*(.62+.38*sin(t*.8));
          vec3 cobalt=vec3(.106,.341,.839);
          vec3 ice=vec3(.62,.82,1.);
          vec3 color=cobalt*wave*.06+ice*scan*.11+ice*orb*.09;
          float alpha=clamp(wave*.024+scan*.1+orb*.07,0.,.38);
          gl_FragColor=vec4(color,alpha);
        }`;

      const compile = (type, source) => {
        const shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) return null;
        return shader;
      };
      const vertex = compile(gl.VERTEX_SHADER, vertexSource);
      const fragment = compile(gl.FRAGMENT_SHADER, fragmentSource);
      if (!vertex || !fragment) { canvas.hidden = true; return; }
      const program = gl.createProgram();
      gl.attachShader(program, vertex);
      gl.attachShader(program, fragment);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) { canvas.hidden = true; return; }
      const buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]), gl.STATIC_DRAW);
      gl.useProgram(program);
      const position = gl.getAttribLocation(program, 'a');
      const resolution = gl.getUniformLocation(program, 'r');
      const time = gl.getUniformLocation(program, 't');
      gl.enableVertexAttribArray(position);
      gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
      let frame = 0;
      let visible = true;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const start = performance.now();
      const draw = (now) => {
        const ratio = Math.min(devicePixelRatio || 1, 1.5);
        const width = Math.max(1, Math.round(hero.clientWidth * ratio));
        const height = Math.max(1, Math.round(hero.clientHeight * ratio));
        if (canvas.width !== width || canvas.height !== height) { canvas.width = width; canvas.height = height; gl.viewport(0, 0, width, height); }
        gl.uniform2f(resolution, width, height);
        gl.uniform1f(time, reduced ? 2.4 : (now - start) / 1000);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
        if (!reduced && visible && !document.hidden) frame = requestAnimationFrame(draw);
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          visible = Boolean(entries[0]?.isIntersecting);
          cancelAnimationFrame(frame);
          if (visible) frame = requestAnimationFrame(draw);
        }, { threshold: 0.05 });
        observer.observe(hero);
      }
      draw(performance.now());
    };

    const initReveals = (root) => {
      const items = [...root.querySelectorAll('[data-dsiv-reveal]')];
      if (!items.length) return;
      items.forEach((item, index) => item.style.setProperty('--dsiv-reveal-delay', `${Math.min(index % 5, 4) * 45}ms`));
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-revealed'));
        return;
      }
      root.classList.add('is-reveal-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });
      items.forEach((item) => observer.observe(item));
    };

    const initCatalog = (root) => {
      const audio = root.querySelector('[data-dsiv-home-audio]');
      if (!audio) return;
      const rows = [...root.querySelectorAll('[data-dsiv-home-track]')];
      const buttons = [...root.querySelectorAll('[data-dsiv-home-play]')];
      const search = root.querySelector('[data-dsiv-home-search]');
      const filters = [...root.querySelectorAll('[data-dsiv-home-filter]')];
      const count = root.querySelector('[data-dsiv-home-count]');
      const empty = root.querySelector('[data-dsiv-home-empty]');
      const live = root.querySelector('[data-dsiv-home-live]');
      const player = root.querySelector('[data-dsiv-home-player]');
      const playerTitle = root.querySelector('[data-dsiv-home-player-title]');
      const playerStatus = root.querySelector('[data-dsiv-home-player-status]');
      const playerCanvas = root.querySelector('[data-dsiv-home-player-canvas]');
      let activeRow = null;
      let activeFilter = 'all';
      let audioContext;
      let analyser;
      let frequencyData;
      let sourceNode;
      let visualFrame = 0;

      const announce = (message) => { if (live) live.textContent = message; };
      const updateCount = () => {
        if (!count) return;
        const visible = rows.filter((row) => !row.hidden).length;
        count.textContent = `${visible} ${visible === 1 ? root.dataset.countSingular : root.dataset.countPlural}`;
        if (empty) empty.hidden = visible !== 0;
      };
      const applyFilters = () => {
        const query = (search?.value || '').trim().toLowerCase();
        rows.forEach((row) => {
          const matchesQuery = !query || row.dataset.search.includes(query);
          const matchesFilter = activeFilter === 'all' || (activeFilter === 'preview' && row.dataset.preview) || (activeFilter === 'available' && row.dataset.available === 'true');
          row.hidden = !(matchesQuery && matchesFilter);
        });
        updateCount();
      };

      const updateButtons = () => {
        const playing = !audio.paused && !audio.ended;
        buttons.forEach((button) => {
          const row = button.closest('[data-dsiv-home-track]');
          const isPlaying = playing && row === activeRow;
          const label = isPlaying ? button.dataset.pauseLabel : button.dataset.playLabel;
          button.setAttribute('aria-label', `${label} ${row.dataset.title}`);
          button.setAttribute('aria-pressed', String(isPlaying));
          button.innerHTML = `<i data-lucide="${isPlaying ? 'pause' : 'play'}" aria-hidden="true"></i>`;
          row.classList.toggle('is-playing', isPlaying);
        });
        window.lucide?.createIcons({ attrs: { 'aria-hidden': 'true' } });
      };

      const updateProgress = () => {
        if (!activeRow) return;
        const duration = Number.isFinite(audio.duration) ? audio.duration : 0;
        const progress = duration ? audio.currentTime / duration * 100 : 0;
        const waveform = activeRow.querySelector('.dsiv-home__waveform');
        const timeline = activeRow.querySelector('[data-dsiv-home-timeline]');
        const status = activeRow.querySelector('[data-dsiv-home-row-status]');
        waveform?.style.setProperty('--progress', `${progress}%`);
        if (timeline) {
          timeline.max = duration || 100;
          timeline.value = audio.currentTime || 0;
          timeline.setAttribute('aria-valuetext', `${formatTime(audio.currentTime)} / ${formatTime(duration)}`);
        }
        if (status) status.textContent = `${formatTime(audio.currentTime)} / ${formatTime(duration)}`;
      };

      const setupAudioGraph = () => {
        if (audioContext || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        try {
          audioContext = new (window.AudioContext || window.webkitAudioContext)();
          analyser = audioContext.createAnalyser();
          analyser.fftSize = 128;
          frequencyData = new Uint8Array(analyser.frequencyBinCount);
          sourceNode = audioContext.createMediaElementSource(audio);
          sourceNode.connect(analyser);
          analyser.connect(audioContext.destination);
        } catch (error) {
          audioContext = null;
        }
      };

      const drawPlayer = () => {
        if (!playerCanvas || !player || player.hidden) return;
        const context = playerCanvas.getContext('2d');
        if (!context) return;
        const ratio = Math.min(devicePixelRatio || 1, 1.5);
        const width = Math.max(1, Math.round(player.clientWidth * ratio));
        const height = Math.max(1, Math.round(player.clientHeight * ratio));
        if (playerCanvas.width !== width || playerCanvas.height !== height) { playerCanvas.width = width; playerCanvas.height = height; }
        context.clearRect(0, 0, width, height);
        const bars = 42;
        if (analyser && frequencyData) analyser.getByteFrequencyData(frequencyData);
        for (let index = 0; index < bars; index += 1) {
          const value = frequencyData ? frequencyData[Math.floor(index / bars * frequencyData.length)] / 255 : 0.18;
          const barWidth = width / bars;
          const barHeight = Math.max(2, value * height * 0.72);
          context.fillStyle = index % 7 === 0 ? 'rgba(255,255,255,.55)' : 'rgba(60,116,245,.62)';
          context.fillRect(index * barWidth, height - barHeight, Math.max(1, barWidth - 2 * ratio), barHeight);
        }
        if (!audio.paused && !audio.ended) visualFrame = requestAnimationFrame(drawPlayer);
      };

      const prepareRow = (row) => {
        if (!row?.dataset.preview) return false;
        if (activeRow !== row) {
          if (activeRow) {
            activeRow.classList.remove('is-playing');
            const previousStatus = activeRow.querySelector('[data-dsiv-home-row-status]');
            if (previousStatus) previousStatus.textContent = root.dataset.previewReady;
          }
          activeRow = row;
          audio.src = row.dataset.preview;
          audio.load();
          if (player) player.hidden = false;
          if (playerTitle) playerTitle.textContent = row.dataset.title;
        }
        return true;
      };

      buttons.forEach((button) => button.addEventListener('click', async () => {
        const row = button.closest('[data-dsiv-home-track]');
        if (row === activeRow && !audio.paused) { audio.pause(); return; }
        if (!prepareRow(row)) return;
        setupAudioGraph();
        if (audioContext?.state === 'suspended') await audioContext.resume();
        try { await audio.play(); } catch (error) { announce(root.dataset.previewError); }
      }));

      rows.forEach((row) => {
        const timeline = row.querySelector('[data-dsiv-home-timeline]');
        timeline?.addEventListener('input', () => {
          if (!prepareRow(row)) return;
          const seek = Number(timeline.value);
          if (Number.isFinite(seek)) audio.currentTime = seek;
          updateProgress();
        });
      });

      search?.addEventListener('input', applyFilters);
      filters.forEach((button) => button.addEventListener('click', () => {
        activeFilter = button.dataset.dsivHomeFilter;
        filters.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        applyFilters();
      }));
      audio.addEventListener('play', () => {
        if (playerStatus) playerStatus.textContent = root.dataset.previewPlaying;
        announce(`${root.dataset.previewPlaying}: ${activeRow?.dataset.title || ''}`);
        updateButtons();
        cancelAnimationFrame(visualFrame);
        drawPlayer();
      });
      audio.addEventListener('pause', () => { if (playerStatus) playerStatus.textContent = root.dataset.previewReady; updateButtons(); drawPlayer(); });
      audio.addEventListener('ended', () => { if (playerStatus) playerStatus.textContent = root.dataset.previewReady; updateButtons(); updateProgress(); });
      audio.addEventListener('timeupdate', updateProgress);
      audio.addEventListener('loadedmetadata', updateProgress);
      audio.addEventListener('error', () => { if (playerStatus) playerStatus.textContent = root.dataset.previewError; announce(root.dataset.previewError); updateButtons(); });
      applyFilters();
    };

    const initChoices = (root) => {
      const buttons = [...root.querySelectorAll('[data-dsiv-license]')];
      const title = root.querySelector('[data-dsiv-license-title]');
      const copy = root.querySelector('[data-dsiv-license-copy]');
      buttons.forEach((button) => button.addEventListener('click', () => {
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        if (title) title.textContent = button.dataset.title;
        if (copy) copy.textContent = button.dataset.copy;
      }));

      const dropButtons = [...root.querySelectorAll('[data-dsiv-drop-view]')];
      const dropText = root.querySelector('[data-dsiv-drop-copy]');
      dropButtons.forEach((button) => button.addEventListener('click', () => {
        dropButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        if (dropText) dropText.textContent = button.dataset.copy;
      }));
    };

    const init = (root) => {
      if (!root || root.dataset.dsivHomeReady === 'true') return;
      root.dataset.dsivHomeReady = 'true';
      const refreshIcons = () => window.lucide?.createIcons({ attrs: { 'aria-hidden': 'true' } });
      refreshIcons();
      document.querySelector('script[src*="lucide.min.js"]')?.addEventListener('load', refreshIcons, { once: true });
      initHero(root);
      initReveals(root);
      initCatalog(root);
      initChoices(root);
    };

    document.querySelectorAll('[data-dsiv-home]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      const loadedSection = event.target.matches?.('[data-dsiv-home]') ? event.target : event.target.querySelector('[data-dsiv-home]');
      init(loadedSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-webgl-stage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function onReady(callback) {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", callback, { once: true });
      } else {
        callback();
      }
    }

    function createShader(gl, type, source) {
      var shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        gl.deleteShader(shader);
        return null;
      }
      return shader;
    }

    function createProgram(gl) {
      var vertexShader = createShader(gl, gl.VERTEX_SHADER, [
        "attribute float a_index;",
        "uniform float u_time;",
        "uniform float u_mode;",
        "uniform vec2 u_pointer;",
        "uniform float u_ratio;",
        "uniform float u_dpr;",
        "varying float v_energy;",
        "varying float v_depth;",
        "float hash(float n) { return fract(sin(n) * 43758.5453123); }",
        "void main() {",
        "  float i = a_index;",
        "  float seed = hash(i * 997.0);",
        "  float pi = 3.14159265359;",
        "  float t = u_time * 0.001;",
        "  vec2 pointer = (u_pointer - 0.5) * 2.0;",
        "  vec2 p = vec2(0.0);",
        "  float energy = 0.0;",
        "  float depth = 0.0;",
        "  if (u_mode < 0.5) {",
        "    float x = i * 2.0 - 1.0;",
        "    float wave = sin((x * 8.0) + t * 2.6) * 0.22 + sin((x * 17.0) - t * 1.4) * 0.08;",
        "    p = vec2(x, wave + (seed - 0.5) * 0.18);",
        "    energy = 0.45 + 0.45 * sin(t * 2.0 + i * 38.0);",
        "    depth = abs(wave);",
        "  } else if (u_mode < 1.5) {",
        "    float ring = floor(i * 7.0);",
        "    float local = fract(i * 7.0);",
        "    float angle = local * pi * 2.0 + t * (0.22 + ring * 0.045);",
        "    float radius = 0.18 + ring * 0.085 + 0.035 * sin(t + seed * 8.0);",
        "    p = vec2(cos(angle) * radius, sin(angle) * radius * 0.74);",
        "    energy = 0.34 + ring * 0.08;",
        "    depth = local;",
        "  } else if (u_mode < 2.5) {",
        "    float columns = 13.0;",
        "    float rows = 9.0;",
        "    float cell = floor(i * columns * rows);",
        "    float col = mod(cell, columns);",
        "    float row = floor(cell / columns);",
        "    p = vec2((col / (columns - 1.0)) * 1.7 - 0.85, (row / (rows - 1.0)) * 1.08 - 0.54);",
        "    p += vec2(sin(t + row), cos(t * 0.8 + col)) * 0.018;",
        "    energy = 0.24 + 0.76 * step(0.72, hash(cell + floor(t * 1.6)));",
        "    depth = hash(cell * 5.0);",
        "  } else {",
        "    float angle = i * pi * 16.0 + t * 0.5;",
        "    float lane = fract(i * 9.0);",
        "    float z = fract(i * 4.0 - t * 0.12);",
        "    float radius = mix(0.9, 0.12, z) + 0.04 * sin(t + seed * 9.0);",
        "    p = vec2(cos(angle) * radius, sin(angle) * radius * 0.62);",
        "    p += vec2((lane - 0.5) * 0.12, 0.0);",
        "    energy = 1.0 - z;",
        "    depth = z;",
        "  }",
        "  p += pointer * (0.04 + seed * 0.035);",
        "  p.x = p.x / max(u_ratio, 1.0);",
        "  gl_Position = vec4(p, 0.0, 1.0);",
        "  gl_PointSize = (2.2 + energy * 5.6 + depth * 3.4) * u_dpr;",
        "  v_energy = energy;",
        "  v_depth = depth;",
        "}"
      ].join("\n"));

      var fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, [
        "precision mediump float;",
        "varying float v_energy;",
        "varying float v_depth;",
        "void main() {",
        "  vec2 center = gl_PointCoord - vec2(0.5);",
        "  float dist = length(center);",
        "  float alpha = smoothstep(0.5, 0.0, dist) * (0.34 + v_energy * 0.58);",
        "  vec3 cobalt = vec3(0.105, 0.341, 0.839);",
        "  vec3 ice = vec3(0.961, 0.973, 1.0);",
        "  vec3 warm = vec3(0.906, 0.714, 0.333);",
        "  vec3 color = mix(cobalt, warm, smoothstep(0.45, 1.0, v_energy));",
        "  color = mix(color, ice, smoothstep(0.72, 1.0, v_depth) * 0.36);",
        "  gl_FragColor = vec4(color, alpha);",
        "}"
      ].join("\n"));

      if (!vertexShader || !fragmentShader) return null;
      var program = gl.createProgram();
      gl.attachShader(program, vertexShader);
      gl.attachShader(program, fragmentShader);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return null;
      return program;
    }

    function initStage(stage) {
      if (!stage || stage.dataset.dsivWebglReady === "true") return;
      stage.dataset.dsivWebglReady = "true";

      var canvas = stage.querySelector("[data-dsiv-webgl-canvas]");
      var gl = canvas && canvas.getContext && canvas.getContext("webgl", { alpha: true, antialias: true });
      if (!gl) {
        stage.classList.add("is-static");
        return;
      }

      var program = createProgram(gl);
      if (!program) {
        stage.classList.add("is-static");
        return;
      }

      var count = 640;
      var data = new Float32Array(count);
      for (var index = 0; index < count; index += 1) {
        data[index] = count > 1 ? index / (count - 1) : 0;
      }

      var buffer = gl.createBuffer();
      var indexLocation = gl.getAttribLocation(program, "a_index");
      var timeLocation = gl.getUniformLocation(program, "u_time");
      var modeLocation = gl.getUniformLocation(program, "u_mode");
      var pointerLocation = gl.getUniformLocation(program, "u_pointer");
      var ratioLocation = gl.getUniformLocation(program, "u_ratio");
      var dprLocation = gl.getUniformLocation(program, "u_dpr");
      var pointer = { x: 0.5, y: 0.5 };
      var mode = 0;
      var active = true;
      var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      gl.useProgram(program);
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
      gl.enableVertexAttribArray(indexLocation);
      gl.vertexAttribPointer(indexLocation, 1, gl.FLOAT, false, 0, 0);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE);

      function resize() {
        var rect = canvas.getBoundingClientRect();
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var width = Math.max(1, Math.floor(rect.width * dpr));
        var height = Math.max(1, Math.floor(rect.height * dpr));
        if (canvas.width !== width || canvas.height !== height) {
          canvas.width = width;
          canvas.height = height;
        }
        gl.viewport(0, 0, canvas.width, canvas.height);
        return {
          ratio: width / Math.max(height, 1),
          dpr: dpr
        };
      }

      function render(now) {
        var size = resize();
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.useProgram(program);
        gl.uniform1f(timeLocation, reducedMotion ? 1600 : now);
        gl.uniform1f(modeLocation, mode);
        gl.uniform2f(pointerLocation, pointer.x, pointer.y);
        gl.uniform1f(ratioLocation, size.ratio);
        gl.uniform1f(dprLocation, size.dpr);
        gl.drawArrays(gl.POINTS, 0, count);
        if (active && !reducedMotion) window.requestAnimationFrame(render);
      }

      var buttons = Array.from(stage.querySelectorAll("[data-dsiv-webgl-mode]"));
      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          mode = Number(button.getAttribute("data-dsiv-webgl-mode")) || 0;
          buttons.forEach(function (item) {
            item.setAttribute("aria-pressed", item === button ? "true" : "false");
          });
          if (reducedMotion) render(performance.now());
        });
      });

      stage.addEventListener("pointermove", function (event) {
        var rect = stage.getBoundingClientRect();
        pointer.x = (event.clientX - rect.left) / Math.max(rect.width, 1);
        pointer.y = 1 - ((event.clientY - rect.top) / Math.max(rect.height, 1));
      });

      if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function (entries) {
          active = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          if (active) window.requestAnimationFrame(render);
        }, { threshold: 0.05 });
        observer.observe(stage);
      }

      window.addEventListener("resize", function () {
        render(performance.now());
      });

      render(performance.now());
    }

    function initAll() {
      Array.from(document.querySelectorAll("[data-dsiv-webgl-stage]")).forEach(initStage);
    }

    onReady(initAll);
    document.addEventListener("shopify:section:load", function (event) {
      initStage(event.target && event.target.querySelector("[data-dsiv-webgl-stage]"));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
